module.exports = __webpack_public_path__ + "img/logo.32e1c342.png";